import { useEffect } from 'react';
import { useUiStore, type ToastItem } from '@renderer/stores/ui-store';
import { useI18n } from '@renderer/shared/i18n';
import styles from './ToastHost.module.css';

function ToastCard({ toast }: { toast: ToastItem }): JSX.Element {
  const dismissToast = useUiStore((state) => state.dismissToast);
  const { t } = useI18n();

  useEffect(() => {
    const timer = window.setTimeout(() => dismissToast(toast.id), 4200);
    return () => window.clearTimeout(timer);
  }, [dismissToast, toast.id]);

  return (
    <article className={`${styles.toast} ${styles[toast.tone]}`}>
      <strong>{toast.title}</strong>
      <p>{toast.message}</p>
      {toast.action ? (
        <button
          type="button"
          onClick={() => {
            toast.action?.onClick();
            dismissToast(toast.id);
          }}
        >
          {toast.action.label}
        </button>
      ) : null}
      <button type="button" onClick={() => dismissToast(toast.id)}>
        {t('common.close')}
      </button>
    </article>
  );
}

export function ToastHost(): JSX.Element {
  const toasts = useUiStore((state) => state.toasts);

  return (
    <div className={styles.host} aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <ToastCard key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
